<template>
  <div id="home-category" :class="['home-category', scrollClassComp]">
    <w-event-processor :category-list="categoryListComp" />
  </div>
</template>

<script setup>
  import WEventProcessor from '@/components/category/Home/WEventProcessor'
  import { useScrollDirection } from '@/common/use/useScrollDirection'
  import { onMounted, onBeforeUnmount, computed } from 'vue'
  import { convertCellEventList } from '@/common/converter/convert-event-list'

  const props = defineProps({
    category: {
      type: Object,
      default: () => {},
    },
  })
  const {
    scrollClassRef,
    lastScrollDirectionRef,
    elementTopOffsetRef,
    lastSrcollTopRef,
    scrollThrottleEvent,
    init: scrollClassInit,
  } = useScrollDirection('home-category')

  const categoryListComp = computed(() => {
    if (!props.category) return []
    const { categoryList } = props.category
    return categoryList?.map((category) => {
      const { code, elementList } = category
      return {
        code,
        text: elementList[0].property?.text,
        eventList: convertCellEventList(elementList),
      }
    })
  })
  const scrollClassComp = computed(() => {
    if (lastScrollDirectionRef.value === 'down') {
      const element = document.getElementById('home-category')
      if (
        !element.classList.contains('scroll-up') &&
        !element.classList.contains('scroll-down')
      ) {
        if (elementTopOffsetRef.value > 20) {
          return ''
        }
      }
    } else {
      if (lastSrcollTopRef.value === 0) {
        return ''
      }
    }
    return scrollClassRef.value
  })

  onMounted(() => {
    scrollClassInit()
    window.addEventListener('scroll', scrollThrottleEvent)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', scrollThrottleEvent)
  })
</script>

<style lang="scss" scoped>
  .home-category {
    position: absolute;
    height: 48px;
    transform: translateY(56px);
    z-index: 101;
    min-width: 100%;
    width: 100%;
    padding: 12px 0;
    background-color: #1b1b1b;
    &::after {
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 100%;
      background: linear-gradient(90deg, rgba(27, 27, 27, 0) 0%, #1b1b1b 100%);
      pointer-events: none;
      content: '';
    }

    &.scroll-up {
      position: fixed;
      transform: translateY(56px);
      transition: transform 0.1s ease-in-out;
      -webkit-transition: transform 0.1s ease-in-out;
    }
    &.scroll-down {
      position: fixed;
      transform: translateY(0);
    }
  }
</style>
